var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84266 0.96373C8.35378 1.18634 8.86535 1.51752 9.42258 2.00448L7.77886 3.64819C7.63821 3.78884 7.55919 3.97961 7.55919 4.17852C7.55919 4.37743 7.63821 4.5682 7.77886 4.70885L10.5348 7.46476L8.87428 9.12525C8.73362 9.2659 8.65461 9.45667 8.65461 9.65558C8.65461 9.85449 8.73362 10.0453 8.87428 10.1859L9.96969 11.2813C10.2626 11.5742 10.7375 11.5742 11.0303 11.2813C11.3232 10.9884 11.3232 10.5136 11.0303 10.2207L10.4653 9.65558L12.1258 7.99509C12.2664 7.85443 12.3454 7.66367 12.3454 7.46476C12.3454 7.26585 12.2664 7.07508 12.1258 6.93443L9.36985 4.17852L11.0303 2.51803C11.8092 1.73922 12.4837 1.25716 13.1574 0.96373C13.8262 0.672414 14.5405 0.546875 15.4294 0.546875C16.8283 0.546875 18.17 1.10261 19.1592 2.09182C20.1484 3.08103 20.7041 4.42269 20.7041 5.82164C20.7041 7.98959 19.2768 9.70979 17.643 11.3107L17.643 11.3107L17.6376 11.3161L10.5 18.4536L3.36246 11.3161L3.36254 11.316L3.3534 11.3072C1.71454 9.72293 0.295898 8.00123 0.295898 5.82164C0.295898 4.42269 0.851631 3.08103 1.84084 2.09182C2.83005 1.10261 4.17171 0.546875 5.57066 0.546875C6.45949 0.546875 7.1738 0.672414 7.84266 0.96373Z",
    fill: "#FFA998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeartIcon);
export default __webpack_public_path__ + "static/media/broken-heart-icon.be3606f0414e2e22d2455624ba205d4d.svg";
export { ForwardRef as ReactComponent };